import { of } from "rxjs";
import { actionCoopInfoLeaveCoopSuccessfully } from "../../cooperative/actionCoop";
export var networkNoticeKickedCoopMemberInfoHandler = function (action$, state$, deps) { return function (res) {
    return of(actionCoopInfoLeaveCoopSuccessfully());
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/handlers/networkNoticeKickedCoopMemberInfoHandler.ts
// module id = 2013
// module chunks = 3